import React from 'react';
import styled from 'styled-components';
import { getIcon } from '../../utils';
import { Flex } from './Flex';

const StyledContactLinks = styled.a`
  & span {
    color: ${(props) => props.$color};
    transition: all 0.25s;
    &:hover {
      color: ${(props) => props.$colorHover};
      transition: all 0.25s;
    }
  }
`;

const StyledIcon = styled.span`
  svg {
    color: ${(props) => props.$color};
    transition: all 0.25s;
    &:hover {
      color: ${(props) => props.$colorHover};
    }
  }
`;

const ContactInfoList = ({ sanity, page }) => {
  const { gbp } = page;
  const { colors } = sanity;

  // Construct the physicalAddress dynamically, filtering out empty values
  const physicalAddress = [
    gbp?.address,
    gbp?.city,
    gbp?.stateShort && `${gbp?.stateShort}`,
    gbp?.zip,
  ]
    .filter(Boolean)
    .join(', ');

  // Define the contact information list
  const contact = [
    {
      id: 1,
      icon: 'Phone',
      anchor: gbp?.phone,
      url: `tel:${gbp?.phone}`,
    },
    {
      id: 2,
      icon: 'Email',
      anchor: gbp?.email,
      url: `mailto:${gbp?.email}`,
    },
    {
      id: 3,
      icon: 'Address',
      anchor: physicalAddress,
      url: gbp?.gbpUrl,
    },
    {
      id: 4,
      icon: 'Hours',
      anchor: gbp?.hoursWeek,
      url: gbp?.gbpUrl,
    },
  ];

  return (
    <Flex classes="flex items-center break-words">
      <ul className="space-y-4">
        {contact.map((info) => {
          const ContactIconComponent = getIcon(info.icon);
          return (
            <li key={info.id}>
              <StyledContactLinks
                $color={colors?.neutral?.white}
                $colorHover={colors?.accent?.lighter}
                href={info.url}
                target="_blank"
                rel="noopener"
                className="flex gap-x-4"
              >
                <StyledIcon
                  $color={colors?.accent?.light}
                  $colorHover={colors?.accent?.lighter}
                  className="mt-1 text-xl"
                >
                  <ContactIconComponent />
                </StyledIcon>
                <span className="text-lg">{info.anchor}</span>
              </StyledContactLinks>
            </li>
          );
        })}
      </ul>
    </Flex>
  );
};

ContactInfoList.displayName = 'ContactInfoList';

export { ContactInfoList };
